<div class="broker-manager-container">
  <div class="page-header">
    <div>
      <h1 class="page-title">Brokers Review</h1>
      <p class="page-subtitle">Manage marriage brokers, monitor generated subscription revenue, and settle wallet payouts.</p>
    </div>
    <button class="btn-refresh" (click)="loadBrokers()">
      <span class="material-symbols-outlined">refresh</span> Refresh
    </button>
  </div>

  <div *ngIf="successMsg" class="alert-success">
    <span class="material-symbols-outlined">check_circle</span> {{ successMsg }}
  </div>

  <div *ngIf="error" class="alert-error">
    <span class="material-symbols-outlined">error</span> {{ error }}
  </div>

  <div *ngIf="loading" class="loading-state">
    <span class="material-symbols-outlined spin">progress_activity</span>
    <span>Loading brokers directory...</span>
  </div>

  <div *ngIf="!loading && brokers.length === 0" class="empty-state">
    <span class="material-symbols-outlined">handshake</span>
    <h3>No Registered Brokers Yet</h3>
    <p>When marriage brokers or agencies register at the Broker Portal, they will appear here.</p>
  </div>

  <div *ngIf="!loading && brokers.length > 0" class="table-card">
    <table class="brokers-table">
      <thead>
        <tr>
          <th>Broker & Agency</th>
          <th>City</th>
          <th>Profiles Listed</th>
          <th>Commission</th>
          <th>Wallet Balance</th>
          <th>Total Earned</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let b of brokers">
          <td>
            <div style="display: flex; align-items: center; gap: 12px;">
              <img *ngIf="b.profile_photo_url" [src]="getImageUrl(b.profile_photo_url)" style="width: 44px; height: 44px; border-radius: 50%; object-fit: cover; border: 2px solid #fff; box-shadow: 0 2px 6px rgba(0,0,0,0.1); flex-shrink: 0;" alt="Avatar">
              <div *ngIf="!b.profile_photo_url" style="width: 44px; height: 44px; border-radius: 50%; background: #f4eaed; color: #B01E3E; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 18px; flex-shrink: 0;">
                {{ b.name.charAt(0) | uppercase }}
              </div>
              <div class="broker-info">
                <span class="broker-name">{{ b.name }}</span>
                <span class="agency-name" *ngIf="b.agency_name">{{ b.agency_name }}</span>
                <span class="agency-name" *ngIf="!b.agency_name" style="color: #888; font-style: italic;">Individual Broker</span>
              </div>
            </div>
          </td>
          <td>
            <span style="color: #444; font-weight: 500; font-size: 13px; display: flex; align-items: center; gap: 4px;">
              <span class="material-symbols-outlined" style="font-size: 16px; color: #B01E3E;">location_on</span>
              {{ b.city || 'N/A' }}
            </span>
          </td>
          <td>
            <span class="count-badge">{{ b.candidates_count || 0 }} profiles</span>
          </td>
          <td>
            <span class="rate-badge" style="background: #fdf8f9; border: 1px solid #e5d5d9; padding: 4px 10px; border-radius: 6px; font-weight: 700; color: #B01E3E;">{{ b.commission_rate || 15 }}%</span>
          </td>
          <td>
            <span class="balance-text" [class.positive]="b.wallet_balance > 0">₹{{ b.wallet_balance || 0 }}</span>
          </td>
          <td>
            <span class="earned-text">₹{{ b.total_earned || 0 }}</span>
          </td>
          <td>
            <span class="status-badge" [class]="b.status">{{ b.status }}</span>
          </td>
          <td class="actions-cell">
            <button class="btn-review" (click)="openReviewModal(b)">
              <span class="material-symbols-outlined">visibility</span> Review
            </button>
            <button class="btn-settle" *ngIf="b.wallet_balance > 0" (click)="openSettleModal(b)" title="Settle Wallet Balance">
              <span class="material-symbols-outlined">payments</span> Settle
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Complete Broker Application Review Modal -->
  <div class="modal-backdrop review-backdrop" *ngIf="reviewModalBroker">
    <div class="modal-card review-modal-card">
      <div class="modal-header">
        <div>
          <h3 style="margin: 0; font-size: 20px; color: #B01E3E;">Review Broker Application</h3>
          <p style="margin: 4px 0 0; font-size: 13px; color: #666; font-weight: normal;">Complete application details and document verification for {{ reviewModalBroker.name }}</p>
        </div>
        <button class="btn-close" (click)="closeReviewModal()"><span class="material-symbols-outlined">close</span></button>
      </div>

      <div class="modal-body review-modal-body">
        <!-- Status Banner -->
        <div class="status-banner" [class]="reviewModalBroker.status">
          <div style="display: flex; align-items: center; gap: 10px;">
            <span class="material-symbols-outlined" style="font-size: 28px;">{{ reviewModalBroker.status === 'active' ? 'check_circle' : reviewModalBroker.status === 'suspended' ? 'block' : 'pending' }}</span>
            <div>
              <strong style="font-size: 15px;">Current Status: {{ reviewModalBroker.status | uppercase }}</strong>
              <div style="font-size: 12px; margin-top: 2px; opacity: 0.9;">{{ reviewModalBroker.status === 'pending' ? 'Application is awaiting manual verification and approval.' : reviewModalBroker.status === 'active' ? 'Broker is verified and actively listing candidate profiles.' : 'Broker account is currently suspended/rejected.' }}</div>
            </div>
          </div>
          <div style="font-size: 12px; font-weight: 600; text-align: right;">
            <div>Registered Date</div>
            <div style="font-size: 13px;">{{ reviewModalBroker.created_at | date:'mediumDate' }}</div>
          </div>
        </div>

        <div class="review-grid">
          <!-- Section 1: Personal Information -->
          <div class="review-section">
            <h4 class="section-title"><span class="material-symbols-outlined">person</span> Personal Information</h4>
            <div class="info-row"><span>Full Name:</span> <strong>{{ reviewModalBroker.name }}</strong></div>
            <div class="info-row"><span>Email Address:</span> <strong>{{ reviewModalBroker.email }}</strong></div>
            <div class="info-row"><span>Mobile Number:</span> <strong>{{ reviewModalBroker.phone }}</strong></div>
            <div class="info-row"><span>Agreed to Terms:</span> <strong style="color: #1e7e48;">Yes (Verified)</strong></div>
          </div>

          <!-- Section 2: Agency Information -->
          <div class="review-section">
            <h4 class="section-title"><span class="material-symbols-outlined">storefront</span> Agency Information</h4>
            <div class="info-row"><span>Agency Name:</span> <strong>{{ reviewModalBroker.agency_name || 'Individual Broker (No Agency)' }}</strong></div>
            <div class="info-row"><span>City / Location:</span> <strong>{{ reviewModalBroker.city || 'N/A' }}</strong></div>
            <div class="info-row" style="flex-direction: column; align-items: flex-start; gap: 4px; border-bottom: none;">
              <span>Office Address:</span>
              <div class="address-box">{{ reviewModalBroker.office_address || 'No office address provided.' }}</div>
            </div>
          </div>

          <!-- Section 3: Experience & Track Record -->
          <div class="review-section">
            <h4 class="section-title"><span class="material-symbols-outlined">work_history</span> Experience & Track Record</h4>
            <div class="info-row"><span>Years of Experience:</span> <strong>{{ reviewModalBroker.years_of_experience || 0 }} Years</strong></div>
            <div class="info-row"><span>Marriages Facilitated:</span> <strong>{{ reviewModalBroker.marriages_facilitated || 0 }} Marriages</strong></div>
            <div class="info-row" style="border-bottom: none;"><span>Active Candidates Listed:</span> <strong>{{ reviewModalBroker.candidates_count || 0 }} Profiles</strong></div>
          </div>

          <!-- Section 4: Commission & Financials -->
          <div class="review-section">
            <h4 class="section-title"><span class="material-symbols-outlined">account_balance</span> Commission & Financials</h4>
            <div class="info-row">
              <span>Commission Percentage:</span>
              <div style="display: flex; align-items: center; gap: 6px;">
                <input type="number" [(ngModel)]="reviewCommissionRate" min="0" max="100" class="form-input" style="width: 80px; padding: 6px 10px; font-weight: bold; color: #B01E3E;">
                <strong>%</strong>
              </div>
            </div>
            <div class="info-row"><span>UPI ID:</span> <strong>{{ reviewModalBroker.bank_details?.upi_id || 'Not provided' }}</strong></div>
            <div class="info-row"><span>Wallet Balance:</span> <strong style="color: #1e7e48;">₹{{ reviewModalBroker.wallet_balance || 0 }}</strong></div>
            <div class="info-row" style="border-bottom: none;"><span>Total Lifetime Earned:</span> <strong>₹{{ reviewModalBroker.total_earned || 0 }}</strong></div>
          </div>
        </div>

        <!-- Section 5: Uploaded Documents (with preview) -->
        <div class="review-section" style="margin-top: 20px;">
          <h4 class="section-title"><span class="material-symbols-outlined">folder_shared</span> Uploaded Documents & Photos</h4>
          <div class="documents-grid">
            <div class="doc-card">
              <div class="doc-label">Selfie / Profile Photo</div>
              <div class="doc-preview">
                <img *ngIf="reviewModalBroker.profile_photo_url" [src]="getImageUrl(reviewModalBroker.profile_photo_url)" alt="Profile Photo">
                <div *ngIf="!reviewModalBroker.profile_photo_url" class="no-doc">No profile photo uploaded</div>
              </div>
              <a *ngIf="reviewModalBroker.profile_photo_url" [href]="getImageUrl(reviewModalBroker.profile_photo_url)" target="_blank" class="doc-link">View Full Size <span class="material-symbols-outlined" style="font-size: 16px;">open_in_new</span></a>
            </div>

            <div class="doc-card">
              <div class="doc-label">Aadhaar or PAN ID Proof</div>
              <div class="doc-preview">
                <img *ngIf="reviewModalBroker.id_proof_url" [src]="getImageUrl(reviewModalBroker.id_proof_url)" alt="ID Proof">
                <div *ngIf="!reviewModalBroker.id_proof_url" class="no-doc">No ID proof uploaded (Optional)</div>
              </div>
              <a *ngIf="reviewModalBroker.id_proof_url" [href]="getImageUrl(reviewModalBroker.id_proof_url)" target="_blank" class="doc-link">View Full Size <span class="material-symbols-outlined" style="font-size: 16px;">open_in_new</span></a>
            </div>
          </div>
        </div>
      </div>

      <!-- At the bottom, provide action buttons: Approve, Reject, Suspend, Save Changes, Close -->
      <div class="modal-footer review-modal-footer">
        <div class="left-actions">
          <button *ngIf="reviewModalBroker.status === 'pending'" class="btn-action-approve" (click)="setStatusFromReview('active')" [disabled]="savingReview">
            <span class="material-symbols-outlined">check_circle</span> Approve
          </button>
          <button *ngIf="reviewModalBroker.status === 'pending'" class="btn-action-reject" (click)="setStatusFromReview('suspended')" [disabled]="savingReview">
            <span class="material-symbols-outlined">cancel</span> Reject
          </button>
          <button *ngIf="reviewModalBroker.status === 'active'" class="btn-action-suspend" (click)="setStatusFromReview('suspended')" [disabled]="savingReview">
            <span class="material-symbols-outlined">pause_circle</span> Suspend
          </button>
          <button *ngIf="reviewModalBroker.status === 'suspended'" class="btn-action-approve" (click)="setStatusFromReview('active')" [disabled]="savingReview">
            <span class="material-symbols-outlined">restore</span> Reactivate
          </button>
        </div>

        <div class="right-actions">
          <button class="btn-cancel" (click)="closeReviewModal()" [disabled]="savingReview">Close</button>
          <button class="btn-action-save" (click)="saveReviewChanges()" [disabled]="savingReview">
            <span class="material-symbols-outlined spin" *ngIf="savingReview">progress_activity</span>
            <span class="material-symbols-outlined" *ngIf="!savingReview">save</span> Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Settle Payout Modal -->
  <div class="modal-backdrop" *ngIf="settleModalBroker">
    <div class="modal-card">
      <div class="modal-header">
        <h3>Settle Broker Payout</h3>
        <button class="btn-close" (click)="closeSettleModal()"><span class="material-symbols-outlined">close</span></button>
      </div>
      <div class="modal-body">
        <p>You are settling wallet earnings for <strong>{{ settleModalBroker.name }}</strong> ({{ settleModalBroker.agency_name || 'Individual Broker' }}).</p>
        
        <div class="bank-box" *ngIf="settleModalBroker.bank_details">
          <div class="bank-title">Bank / UPI Details</div>
          <div><strong>Account Holder:</strong> {{ settleModalBroker.bank_details.account_holder || 'N/A' }}</div>
          <div><strong>Account No:</strong> {{ settleModalBroker.bank_details.account_number || 'N/A' }}</div>
          <div><strong>IFSC Code:</strong> {{ settleModalBroker.bank_details.ifsc_code || 'N/A' }}</div>
          <div><strong>UPI ID:</strong> {{ settleModalBroker.bank_details.upi_id || 'N/A' }}</div>
        </div>

        <div class="form-group" style="margin-top: 16px;">
          <label>Settlement Amount (₹)</label>
          <input type="number" [(ngModel)]="settleAmount" [max]="settleModalBroker.wallet_balance" min="1" class="form-input">
          <span class="help-text">Max available: ₹{{ settleModalBroker.wallet_balance }}</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeSettleModal()" [disabled]="settling">Cancel</button>
        <button class="btn-confirm-settle" (click)="confirmSettle()" [disabled]="settling || settleAmount <= 0">
          <span class="material-symbols-outlined spin" *ngIf="settling">progress_activity</span>
          {{ settling ? 'Settling...' : 'Mark as Paid & Deduct Wallet' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Edit Commission Rate Modal -->
  <div class="modal-backdrop" *ngIf="commissionModalBroker">
    <div class="modal-card">
      <div class="modal-header">
        <h3>Adjust Commission Rate</h3>
        <button class="btn-close" (click)="closeCommissionModal()"><span class="material-symbols-outlined">close</span></button>
      </div>
      <div class="modal-body">
        <p>Set custom commission percentage for <strong>{{ commissionModalBroker.name }}</strong>.</p>
        <div class="form-group">
          <label>Commission Rate (%)</label>
          <input type="number" [(ngModel)]="newCommissionRate" min="0" max="100" class="form-input">
          <span class="help-text">Default is 15%. This percentage applies whenever their candidates upgrade to a paid plan.</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeCommissionModal()" [disabled]="updatingCommission">Cancel</button>
        <button class="btn-confirm-rate" (click)="confirmCommission()" [disabled]="updatingCommission">
          {{ updatingCommission ? 'Saving...' : 'Update Commission %' }}
        </button>
      </div>
    </div>
  </div>
</div>
